export const data = [
  {
    id: 0,
    name: "Naziv dokumenta",
    path: "putanja_do_dokumenta.pdf",
    date: new Date("2024-01-03 00:00:00"),
  },
  {
    id: 1,
    name: "Naziv dokumenta",
    path: "putanja_do_dokumenta.pdf",
    date: new Date("2024-01-07 00:00:00"),
  },
  {
    id: 2,
    name: "Naziv dokumenta",
    path: "putanja_do_dokumenta.pdf",
    date: new Date("2024-01-10 00:00:00"),
  },
  {
    id: 3,
    name: "Naziv dokumenta",
    path: "putanja_do_dokumenta.pdf",
    date: new Date("2024-01-20 00:00:00"),
  },
  {
    id: 4,
    name: "Naziv dokumenta",
    path: "putanja_do_dokumenta.pdf",
    date: new Date("2024-01-25 00:00:00"),
  },
  {
    id: 5,
    name: "Naziv dokumenta",
    path: "putanja_do_dokumenta.pdf",
    date: new Date("2024-01-28 00:00:00"),
  },
  {
    id: 6,
    name: "Naziv dokumenta",
    path: "putanja_do_dokumenta.pdf",
    date: new Date("2024-01-20 00:00:00"),
  },
  {
    id: 7,
    name: "Naziv dokumenta",
    path: "putanja_do_dokumenta.pdf",
    date: new Date("2024-01-23 00:00:00"),
  },
  {
    id: 8,
    name: "Naziv dokumenta",
    path: "putanja_do_dokumenta.pdf",
    date: new Date("2024-01-27 00:00:00"),
  },
  {
    id: 9,
    name: "Naziv dokumenta",
    path: "putanja_do_dokumenta.pdf",
    date: new Date("2024-01-13 00:00:00"),
  },
  {
    id: 10,
    name: "Naziv dokumenta",
    path: "putanja_do_dokumenta.pdf",
    date: new Date("2024-01-11 00:00:00"),
  },
  {
    id: 11,
    name: "Naziv dokumenta",
    path: "putanja_do_dokumenta.pdf",
    date: new Date("2024-01-15 00:00:00"),
  },
];
